import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PermissionsService } from 'src/app/core/services/simulation/permission/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class FieldsAccessService {
  canEdit = new BehaviorSubject(true);

  constructor(private permissionsService: PermissionsService) {}

  updateAccessLevel(): void {
    const canEditState = this.permissionsService.canEdit();
    this.canEdit.next(canEditState);
  }

  ignoreAccess(): void {
    this.canEdit.next(true);
  }
}
